import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask"; 
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { StyledForm } from "../../styled-components/StyledForm.style";

// Recebemos 'registroEdicao' (o ID) que é o objeto clicado na listagem pai
export const ModalCalendarioIndisponibilidadesEditar = ({ isOpen, setIsOpen, registroEdicao, onRequestClose }) => {
    const [isLoading, setisLoading] = useState(false);
    const [dados, setDados] = useState(null);    

    // Estados para os campos editáveis
    const [dataInicio, setDataInicio] = useState(null);
    const [dataFim, setDataFim] = useState(null);
    const [justificativa, setJustificativa] = useState("");

    const style = {
        content: {
            top: '50%', left: '50%', right: 'auto', bottom: 'auto',
            marginRight: '-50%', transform: 'translate(-50%, -50%)',
            borderRadius: "0px", minWidth: '50%', overflowY: 'auto', 
            minHeight: '50%', maxHeight: '90%'
        },
        overlay: { zIndex: 9999 }
    };

    const closeModal = () => {
        setJustificativa("");
        setisLoading(false);
        setIsOpen(false);
        if (onRequestClose) onRequestClose();
    };

    const carregarRegistro = async (id) => {
        setisLoading(true);
        try {
            const response = await api.get(`WipFeriasAusencias/${id}`);
            const data = response.data.data;
            setDados(data);
            setDataInicio(new Date(data.dataInicio));
            setDataFim(new Date(data.dataFim));
            setJustificativa(data.justificativaOcorrencia || "");
        } catch (error) {
            console.error("Erro ao carregar registro:", error);
            Swal.fire('Erro', 'Não foi possível carregar os dados.', 'error');
            closeModal();
        } finally {
            setisLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen && registroEdicao) {
            carregarRegistro(registroEdicao);
        }
    }, [isOpen, registroEdicao]);

    const handleSalvar = async () => {
        // 1. Validação de campos obrigatórios (se algo estiver null ou undefined)
        if (!dataInicio || !dataFim) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Preencha as duas datas (Início e Fim) corretamente antes de salvar.'
            });
            return;
        }

        // 2. Validação de lógica de datas (Fim antes do Início)
        if (new Date(dataFim) < new Date(dataInicio)) {
            Swal.fire({
                icon: 'error',
                title: 'Erro de Datas',
                text: 'A data de fim não pode ser anterior à data de início.'
            });
            return;
        }

        // 3. Validação de ano (Seguindo sua regra de perfumaria anterior)
        const anoOriginal = new Date(dados.dataInicio).getFullYear();
        if (dataInicio.getFullYear() !== anoOriginal || dataFim.getFullYear() !== anoOriginal) {
            Swal.fire({
                icon: 'error',
                title: 'Ano Inválido',
                text: `As datas devem pertencer ao ano de ${anoOriginal}.`
            });
            return;
        }

        // 4. Validação de justificativa 
         if (!justificativa || justificativa.trim() === "") {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Preencha a justificativa antes de salvar.'
            });
            return;
        }

        setisLoading(true);

        const payload = {
            ...dados,
            dataInicio: dataInicio,
            dataFim: dataFim,
            justificativaOcorrencia: justificativa
        };

        try {
            // Só chega aqui se todas as validações acima passarem
            await api.put(`WipFeriasAusencias/${registroEdicao}`, payload);
            
            Swal.fire('Sucesso', 'Indisponibilidade atualizada com sucesso!', 'success').then(() => {
                closeModal();
            });
        } catch (error) {
            setisLoading(false);
            const msg = error.response?.data?.notification?.messageReturn || 'Erro desconhecido ao salvar.';
            Swal.fire('Erro', msg, 'error');
        } finally {
            setisLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Editar Indisponibilidade"
            style={style}
            ariaHideApp={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <i className="fa fa-calendar-check-o pe-2" style={{ fontSize: '24px', color: '#EE4B21' }}></i>
                                    Editar Férias / Ausências
                                </p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button type="button" className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                
                { isLoading ? (
                    <div className="text-center py-4">
                        <div className="spinner-border" style={{ color: "#EE4B21" }} role="status"></div>
                        <div className="mt-2">
                            <strong style={{ color: "#EE4B21" }}>Carregando dados...</strong>
                        </div>
                    </div>
                ) : (
                    <div style={{ padding: '0 10px 20px 10px' }}>
                        
                        {/* ÁREA DE INFORMAÇÕES (READ-ONLY) */}
                        <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '4px', marginBottom: '20px', border: '1px solid #e9ecef' }}>
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontWeight: 'bold', fontSize: '12px', color: '#6c757d', marginBottom: '4px', display: 'block' }}>Profissional</label>
                                    <p style={{ margin: 0, fontWeight: 'bold', fontSize: '16px' }}>{dados?.nomeProfissional || '...'}</p>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontWeight: 'bold', fontSize: '12px', color: '#6c757d', marginBottom: '4px', display: 'block' }}>Tipo de Ausência</label>
                                    <p style={{ margin: 0, fontWeight: 'bold', fontSize: '16px' }}>{dados?.tipoDescricao || '...'}</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '20px', marginTop: '15px', paddingTop: '15px', borderTop: '1px dashed #ccc' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontWeight: 'bold', fontSize: '12px', color: '#6c757d', marginBottom: '4px', display: 'block' }}>Data de Início Original</label>
                                    <p style={{ margin: 0, fontWeight: 'bold', fontSize: '14px', color: '#495057' }}>
                                        {dados?.dataInicio ? new Date(dados.dataInicio).toLocaleDateString('pt-BR') : '--/--/----'}
                                    </p>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontWeight: 'bold', fontSize: '12px', color: '#6c757d', marginBottom: '4px', display: 'block' }}>Data de Fim Original</label>
                                    <p style={{ margin: 0, fontWeight: 'bold', fontSize: '14px', color: '#495057' }}>
                                        {dados?.dataFim ? new Date(dados.dataFim).toLocaleDateString('pt-BR') : '--/--/----'}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* ÁREA DE EDIÇÃO */}
                        <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
                            <div style={{ flex: 1 }}>
                                <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>Nova Data de Início</label>
                                <DatePicker 
                                    dateFormat="dd/MM/yyyy" locale="pt-BR" selected={dataInicio}
                                    onChange={(date) => setDataInicio(date)} className="input-form py-2"
                                    customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>Nova Data de Fim</label>
                                <DatePicker 
                                    dateFormat="dd/MM/yyyy" locale="pt-BR" selected={dataFim}
                                    onChange={(date) => setDataFim(date)} className="input-form py-2"
                                    minDate={dataInicio}
                                    customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                />
                            </div>
                        </div>

                        <div className="row align-items-center justify-content-center">
                            <div className="col text-center">
                                <DynamicTextareaOnChange 
                                    placeholder={"Digite a justificativa para esta alteração"} 
                                    label={"Justificativa"} 
                                    name={"justificativa"}
                                    valuetext={justificativa}
                                    onChange={(e) => setJustificativa(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '15px' }}>
                            <button type="button" onClick={handleSalvar} style={{ padding: '10px 15px', fontSize: '14px', cursor: 'pointer', backgroundColor: '#EE4B21', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold' }}>Salvar Alterações</button>
                        </div>
                    </div>
                )}
            </StyledForm>
        </Modal>
    );
};